export default __webpack_public_path__ + "f36c25fd20b000f4fee65043127e50c1.png";